import { useState } from "react";
import { Loader2, Flower2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";
import { Field, btnPrimary, inputCls } from "@/components/app/common";

const HERO = "https://images.unsplash.com/photo-1772191530787-b9546da02fbc?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";

export default function Login() {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
    } catch (err) {
      setError(errMsg(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid lg:grid-cols-2 bg-[#FAF7F5]">
      <div className="hidden lg:block relative overflow-hidden">
        <img src={HERO} alt="Cosmetici" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#2C2623]/55 via-transparent to-transparent" />
        <div className="absolute bottom-12 left-12 right-12 text-white">
          <div className="text-[11px] uppercase tracking-[0.2em] opacity-80 mb-3">Controllo di gestione</div>
          <p className="font-display text-3xl leading-snug max-w-md">Incassi, costi e margini della tua bellezza, in un solo sguardo.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <form onSubmit={submit} className="w-full max-w-sm fade-up" data-testid="login-form">
          <span className="h-12 w-12 rounded-full bg-[#E8C5C8]/60 grid place-items-center mb-8">
            <Flower2 className="h-6 w-6 text-[#8C6D62]" />
          </span>
          <div className="overline-label mb-2">Cosmetica Control</div>
          <h1 className="text-4xl font-medium mb-2">Bentornata</h1>
          <p className="text-sm text-[#756B64] mb-8">Accedi con le tue credenziali per continuare.</p>
          <div className="space-y-4">
            <Field label="Email">
              <Input data-testid="login-email-input" type="email" required autoComplete="email" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="nome@azienda.it" />
            </Field>
            <Field label="Password">
              <Input data-testid="login-password-input" type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
            </Field>
            {error && <div data-testid="login-error" className="text-sm text-[#B4553D] bg-[#E07A5F]/10 rounded-xl px-3 py-2">{error}</div>}
            <Button data-testid="login-submit-button" type="submit" disabled={loading} className={`${btnPrimary} w-full h-11`}>
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Accedi"}
            </Button>
          </div>
        </form>
      </div>
    </div>
  );
}
